// extracted by mini-css-extract-plugin
export default {"closeButton":"ModalBase_closeButton__9tCdp"};